import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import MenuCategoryItemsModal from "../../components/Category/MenuCategoryItemsModal";
import PromotionHelper from "../../../../services/Menu/services/Promotion/PromotionHelper";
import AvailableHelper from "../../../../services/Menu/services/Availability/AvailableHelper";
import {RootState} from "../../../../../reducers";
import {
    getAvailabilities,
    getCategories,
    getItemGroups,
    getItems,
    getMenus,
    getPromotions
} from "../../../../services/Menu/reducer";
import {getSession, selectLocale} from "../../../../services/Session/reducer";
import {getStoreConfig} from "../../../../services/Store/reducer";
import {getCart} from "../../../../services/Cart/reducer";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import CategoryHelper from "../../../../services/Menu/services/Category/CategoryHelper";
import IframeWidget from "../../../../utils/IframeWidget";
import StoreUtils from "../../../../services/Store/StoreUtils";
import AgeRestrictedContext from "../../../../services/Common/AgeRestrictedContext";

interface OwnProps {
    menuId?: number;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MenuCategoryPage = ({
                              promotions,
                              cart,
                              items,
                              categories,
                              availabilities,
                              session,
                              itemGroups,
                              menus,
                              config,
                              locale,
                              menuId
                          }: Props) => {
    const {id} = useParams<{ id?: string }>();
    const [showModal, setShowModal] = useState(true);
    let categoryMenus: any[] = [];
    const isMultilevelMenu = StoreUtils.isMultilevelMenu(config);

    useEffect(() => {
        return () => {
            IframeWidget.closeModal()
        }
    }, []);

    const getParsedCategory = () => {
        const availablePromotions = PromotionHelper.getActivePromotionsForCategory(promotions, cart.total);
        const {menu, categories: menuCategories} = CategoryHelper.findCategoriesForMenu(categories, menus, menuId);
        const finalCategories = isMultilevelMenu ? [...menuCategories] : [...categories];
        const categoryById = finalCategories.find((category: any) => category.status === 'ENABLED' && Number(id) === category.id);
        const allCategoriesWithSameName = finalCategories.filter((category: Record<string, any>) => category.status === 'ENABLED' && category.name === categoryById.name);
        const parsedCategory = CategoryHelper.getParsedCategories(
            allCategoriesWithSameName,
            items,
            availabilities,
            availablePromotions,
            session,
            cart,
            itemGroups,
            menus,
            AgeRestrictedContext.isAccepted(StoreUtils.isAgeRestrictionDisabled(config)),
            isMultilevelMenu,
            menuId)[0];

        if (parsedCategory.entities.length === 0) return undefined;

        const menusWithCategory = isMultilevelMenu ? (menu ? [menu] : []) : CategoryHelper.getMenusForCategoryByIds(parsedCategory, menus);
        const menuAvailabilities = AvailableHelper.getAvailabilities(availabilities, menusWithCategory.map((menu: any) => menu.availability_id));
        categoryMenus = [...menusWithCategory];
        return menuAvailabilities.length > 0 ? parsedCategory : undefined;
    }

    const category = getParsedCategory();

    if (!category) return <></>;

    return (
        <MenuCategoryItemsModal show={showModal} category={category} setShowModal={setShowModal} config={config}
                                availabilities={availabilities} locale={locale} menus={categoryMenus}
                                session={session} promotions={promotions} menuId={menuId}/>
    )
}

const mapStateToProps = (state: RootState) => ({
    availabilities: getAvailabilities(state.menu),
    promotions: getPromotions(state.menu),
    categories: getCategories(state.menu),
    items: getItems(state.menu),
    itemGroups: getItemGroups(state.menu),
    session: getSession(state.session),
    config: getStoreConfig(state.config),
    cart: getCart(state.cart),
    menus: getMenus(state.menu),
    locale: selectLocale(state.session),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuCategoryPage));
